
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useUser } from '@/contexts/user-context';
import { useBranding } from '@/contexts/branding-context';
import { TenantLogoSmall } from '@/components/shared/tenant-logo';
import { LanguageSwitcher } from '@/components/language-switcher';
import { ThemeToggle } from '@/components/theme-toggle';

export function UserNav() {
  const { t } = useTranslation();
  const { user, logout } = useUser();
  const { primaryColor } = useBranding();

  if (!user) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full overflow-hidden p-0 shrink-0">
          <span
            className="h-8 w-8 rounded-full overflow-hidden flex items-center justify-center border-2 p-0.5"
            style={{ borderColor: primaryColor }}
          >
            <TenantLogoSmall className="h-full w-full rounded-full object-contain" />
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{`${user.name} ${user.surname}`}</p>
            <p className="text-xs leading-none text-muted-foreground">
              {user.email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => (window.location.href = '/profile')}>
            {t('userNav.profile')}
          </DropdownMenuItem>
          {(user?.userType === 'owner' ||
            user?.role === 'owner' ||
            user?.userType === 'admin' ||
            user?.role === 'admin' ||
            user?.isAdmin === true) && (
            <DropdownMenuItem onClick={() => (window.location.href = '/gym-settings')}>
              {t('userNav.gymSettings')}
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <div className="flex gap-2 px-2 py-1">
          <ThemeToggle />
          <LanguageSwitcher />
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout}>
          {t('userNav.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
